module.exports = __webpack_public_path__ + "5fdc603158eb4b88210570c17b8b2bb8.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1/public/history/fi-2011.png
// module id = 369
// module chunks = 0